import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  Menu,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  TextField,
  TextareaAutosize,
} from "@mui/material";
import React, { useEffect } from "react";
import "./SupplierCreation.scss";
import { useState } from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { PhoneNumberUtil } from "google-libphonenumber";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CreatableSelect from "react-select/creatable";
import { t } from "i18next";
import { neutral, primaryColor } from "../../../constants/colorConstants";
import {
  checkDuplicateSupplier,
  createAdditionalField,
  createSupplier,
  getOrgAdditionalFields,
  getSupplierDetails,
  sendRegistrationRequest,
  updateSupplier,
} from "../../../services/srmService";
import { useNavigate } from "react-router-dom";
import MapsInput from "../../common/MapsInput";
import { Cascader } from "antd";
import { industriesService } from "../../../services/orgService";
import { CaretDownOutlined } from "@ant-design/icons";
import { bulkUploadService } from "../../../services/emissionService";
import { EMAIL_REGEX } from "../../../constants/regexConstants";
import { toastMessage } from "../../../helper";
// import  "../../common/MapsInput.scss";
export default function SupplierCreation() {
  enum SUPPLIER_STEPS {
    "BASIC_DETAILS" = "Basic Details",
    "PREFERENCES" = "Preferences",
  }
  const [step, setStep] = useState(SUPPLIER_STEPS.BASIC_DETAILS);
  const navigate = useNavigate();
  const phoneUtil = PhoneNumberUtil.getInstance();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSaveMenuClose = (sendRequest?: boolean) => {
    setAnchorEl(null);
    if (sendRequest != undefined) {
      handleSave(sendRequest);
    }
  };

  const [fieldOptions, setFieldOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const handleNext = () => {
    if (data.email != "") {
      if (!EMAIL_REGEX.test(data.email)) {
        toastMessage("Invalid Primary Email", "error");
        return;
      }
    } else {
      toastMessage("Primary Email Required", "error");
      return;
    }
    if (data.secondaryEmail != "") {
      if (!EMAIL_REGEX.test(data.secondaryEmail)) {
        toastMessage("Invalid Secondary Email", "error");
        return;
      }
    } else {
      toastMessage("Secondary Email is required", "error");
      return;
    }
    if (!data.contactName) {
      toastMessage("Contact name required", "error");
      return;
    }
    if (!data.name) {
      toastMessage("Supplier name required", "error");
      return;
    }
    if (data.phone) {
      if (!isPhoneValid(data.dialCode + " " + data.phone)) {
        toastMessage("Invalid Phone", "error");
        return;
      }
    }
    setStep(SUPPLIER_STEPS.PREFERENCES);
  };

  const handleSave = async (sendRequest?: boolean) => {
    if (Object.keys(supplierData).length) {
      if (!(data.isSupplier || data.isBorrower)) {
        toastMessage("Please select type of supplier", "error");
        return;
      }
      let emailRes = await checkDuplicateSupplier("email", data.email);
      if (emailRes.data.exists) {
        if (
          emailRes.data.email != supplierData.email ||
          Object.keys(supplierData).length == 0
        ) {
          toastMessage(
            "Another supplier already exists with the email",
            "error"
          );
          return;
        }
      }
      let registrationRes = await checkDuplicateSupplier(
        "registration_id",
        data.registrationId
      );
      if (registrationRes.data.exists) {
        if (
          registrationRes.data.registration_id !=
            supplierData.registration_id ||
          Object.keys(supplierData).length == 0
        ) {
          toastMessage(
            "Another supplier already exists with the registration id",
            "error"
          );
          return;
        }
      }
    }

    if (data.preferences.reportWindow) {
      data.preferences.reportWindow = Number(data.preferences.reportWindow);
    }
    if (isEdit) {
      supplierData.name = data.name;
      supplierData.contact_name = data.contactName;
      supplierData.industry = data.industry;
      supplierData.phone = data.phone;
      supplierData.dial_code = data.dialCode;
      supplierData.email = data.email;
      supplierData.secondary_contact_name = data.secondaryContactName;
      supplierData.secondary_email = data.secondaryEmail;
      supplierData.registration_id = data.registrationId;
      supplierData.logo = data.logo;
      supplierData.address = data.address;
      supplierData.remarks = data.remarks;
      supplierData.preferences.frequency = data.preferences.frequency;
      supplierData.preferences.report_window = data.preferences.reportWindow;
      supplierData.preferences.emissions_captured =
        data.preferences.emissionsCaptured;
      supplierData.fields = data.fields;
      updateSupplier(supplierData).then((update) => {
        window.location.href =
          window.location.origin + "/partners/suppliers/list";
        toastMessage("Supplier updated sucessfully", "success");
      });
    } else {
      createSupplier(data)
        .then((resp) => {
          if (sendRequest) {
            sendRegistrationRequest(resp.data.id).then((res) => {
              toastMessage("Supplier created and request sent", "sucess");
              navigate("/partners/suppliers/list");
            });
          } else {
            toastMessage("Supplier created", "sucess");
            navigate("/partners/suppliers/list");
          }
        })
        .catch((e) => {
          toastMessage(e.response?.data?.message, "error");
        });
    }
  };

  const handleImageSelection = (event: any) => {
    if (event.target.files.length > 0) {
      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      bulkUploadService(formData).then((res) => {
        data.logo = res.data.Location;
        setData({ ...data });
      });
    }
  };

  const [enableNext, setEnableNext] = useState(false);
  const [enableSave, setEnableSave] = useState(false);
  const [data, setData] = useState<any>({
    name: "",
    contactName: "",
    industry: null,
    phone: "",
    dialCode: "",
    email: "",
    secondaryContactName: "",
    secondaryEmail: "",
    registrationId: "",
    logo: "assets/images/camera.png",
    address: "",
    remarks: "",
    fields: [],
    isSupplier: false,
    isBorrower: false,
    preferences: {
      frequency: "Monthly",
      reportWindow: 0,
      emissionsCaptured: "scope-1-2",
    },
  });

  const handleTypeSelection = (e: any, type: string) => {
    if (type == "Supplier") {
      data.isSupplier = e.target.checked;
    } else {
      data.isBorrower = e.target.checked;
    }
  };

  const handleCancel = () => {
    navigate("/partners/suppliers/list");
  };

  const handlePreferenceInput = (e: any, key: any) => {
    data.preferences[key] = e.target.value;
    setData({ ...data });
  };
  const addNewField = () => {
    data.fields.push({
      name: "",
      value: "",
    });
    setData({ ...data });
  };

  const handleFieldChangeSelect = (newValue: any, field: any) => {
    field.name = newValue.label;
    setData(JSON.parse(JSON.stringify(data)));
  };

  const [industries, setIndustries] = useState([] as any[]);
  const onChangeAddress = (e: any) => {
    console.log(e);
  };

  const filter = (inputValue: string, path: any) => {
    return path.some(
      (option: any) =>
        option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
  };
  const handleInputChange = (e: any, field: any) => {
    if (field === "phone") {
      let dialCode = e.split(" ")[0];
      data["dialCode"] = dialCode;
      data["phone"] = e.substring(dialCode.length + 1);
    } else if (field == "industry") {
      data["industry"] = industries
        .filter((item) => item.label == e[0])[0]
        .children.filter((item: any) => item.label == e[1])[0].id;
      setIndustryData([...e]);
    } else if (field === "name") {
      data["name"] = e.target.value.toUpperCase();
    } else {
      data[field] = e.target.value;
    }
    setData({ ...data });
  };

  const isPhoneValid = (phone: string) => {
    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
      return false;
    }
  };

  const [industryData, setIndustryData] = useState<any[]>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [supplierData, setSupplierData] = useState<any>({}); // to store created supplier for edit.

  useEffect(() => {
    fetchIndustryData().then(() => {
      fetchOrgSupplierFields().then((res) => {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get("supplier")) {
          setIsEdit(true);
          getSupplierDetails(Number(searchParams.get("supplier")))
            .then((supplierRes) => {
              let supplierData = supplierRes.data;
              setSupplierData(supplierData);
              data.name = supplierData.name;
              data.contactName = supplierData.contact_name;
              industries.forEach((reportingOrg) => {
                reportingOrg.children.forEach((industry: any) => {
                  if (industry.id == supplierData.industry) {
                    console.log(reportingOrg);
                    console.log(industry.value);
                    setIndustryData([reportingOrg.value, industry.value]);
                  }
                });
              });
              data.industry = supplierData.industry;
              data.phone = supplierData.phone;
              data.dialCode = supplierData.dial_code;
              data.email = supplierData.email;
              data.secondaryContactName = supplierData.secondary_contact_name;
              data.secondaryEmail = supplierData.secondary_email;
              data.registrationId = supplierData.registration_id;
              data.logo = supplierData.logo;
              data.address = supplierData.address;
              data.remarks = supplierData.remarks;
              data.preferences.frequency = supplierData.preferences.frequency;
              data.preferences.reportWindow =
                supplierData.preferences.report_window;
              data.preferences.emissionsCaptured =
                supplierData.preferences.emissions_captured;
              data.fields = supplierData.fields;
              setData(JSON.parse(JSON.stringify(data)));
            })
            .catch((err) => {
              console.log(err);
              toastMessage(err.response.data.message, "error");
            });
        }
      });
    });
  }, []);

  useEffect(() => {
    const checkEnableNext =
      data?.name?.length &&
      data?.contactName?.length &&
      data?.email?.length &&
      EMAIL_REGEX.test(data?.email) &&
      data?.secondaryContactName?.length &&
      data?.secondaryEmail?.length &&
      EMAIL_REGEX.test(data?.secondaryEmail) &&
      data?.industry &&
      data?.registrationId?.length &&
      (data?.isSupplier || data?.isBorrower);
    setEnableNext(!!checkEnableNext);
    setEnableSave(!!checkEnableNext);
  }, [data]);

  const fetchOrgSupplierFields = async () => {
    let res = await getOrgAdditionalFields();
    if (res.status == 200) {
      let fields = res.data.map((item: any) => {
        return { label: item, value: item };
      });
      setFieldOptions(fields);
    } else {
      toastMessage(res.data.error, "error");
    }
  };

  const clearFieldInput = (field: any) => {
    field.name = "";
    setData({ ...data });
  };

  const handleAddInputChange = (e: any, field: any, key: any) => {
    field[key] = e.target.value;
  };

  const handleFieldCreateOption = async (inputValue: any, field: any) => {
    const newOption = {
      label: inputValue,
      value: inputValue.trim(),
    };
    await createAdditionalField(inputValue);
    setFieldOptions([...fieldOptions, newOption]);
    field.name = newOption.value;
    setData(JSON.parse(JSON.stringify(data)));
  };

  const fetchIndustryData = async () => {
    const indusRes = await industriesService();
    industries.length = 0;
    indusRes.data.map((each: any) => {
      const childrenData: any = [];
      each.children.map((eachchildren: any) => {
        childrenData.push({
          value: eachchildren.name,
          label: eachchildren.name,
          id: eachchildren.id,
        });
      });
      const currData = {
        value: each.code,
        label: each.code,
        children: [...childrenData],
      };
      industries.push(currData);
    });
    setIndustries([...industries]);
  };
  const [phone, setPhone] = useState("");

  return (
    <div className="pw-supplier-creation-page flex">
      <div className="w-1/5" style={{ background: neutral[200] }}>
        <div
          className={`pw-cursor-pointer pw-org-side-elem ${
            SUPPLIER_STEPS.BASIC_DETAILS == step ? "pw-step-active" : ""
          }`}
        >
          Basic Details
        </div>
        <div
          className={`pw-org-side-elem pw-cursor-pointer ${
            SUPPLIER_STEPS.PREFERENCES == step ? "pw-step-active " : ""
          }`}
        >
          Preferences
        </div>
      </div>
      <div className="pw-supplier-creation  overflow-y-auto gap-y-2 w-4/5">
        <span className="text-2xl font-bold mb-6 pl-8">
          Add Suppliers/Borrowers
        </span>

        <div
          style={{
            display: SUPPLIER_STEPS.BASIC_DETAILS === step ? "block" : "none",
          }}
        >
          <div className="pl-8">
            <div className="flex flex-row gap-x-12">
              <div className="flex flex-col gap-y-2">
                <div>
                  <span className="pw-input-label">
                    Contact type <span className="pw-mandatory-icon">*</span>
                  </span>
                  <FormGroup sx={{ flexDirection: "row", marginTop: "5px" }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(e) => handleTypeSelection(e, "Supplier")}
                        />
                      }
                      label="Supplier"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(e) => handleTypeSelection(e, "Borrower")}
                        />
                      }
                      label="Borrower"
                    />
                  </FormGroup>
                </div>
                <span className="pw-input-label">
                  Company name <span className="pw-mandatory-icon">*</span>
                </span>
                <OutlinedInput
                  id="pw-e2e-supcmpyname"
                  value={data["name"]}
                  onChange={(e) => handleInputChange(e, "name")}
                />
                <span className="pw-input-label">
                  Primary contact name{" "}
                  <span className="pw-mandatory-icon">*</span>
                </span>
                <OutlinedInput
                  id="pw-e2e-prmycontactname"
                  value={data["contactName"]}
                  onChange={(e) => handleInputChange(e, "contactName")}
                />
                <span className="pw-input-label">
                  Primary contact email ID
                  <span className="pw-mandatory-icon">*</span>
                </span>
                <OutlinedInput
                  id="pw-e2e-prmycontactmail"
                  type="email"
                  value={data["email"]}
                  onChange={(e) => handleInputChange(e, "email")}
                />
                <span className="pw-input-label">Contact no.</span>
                <PhoneInput
                  className="pw-e2e-supcontact"
                  value={data["dialCode"] + " " + data["phone"]}
                  initialCountry="in"
                  forceDialCode
                  onChange={(phone) => handleInputChange(phone, "phone")}
                />
              </div>
              <div>
                <div className="flex flex-col my-20 ml-12">
                  <label htmlFor="supplier-profile">
                    {" "}
                    <img
                      className="pw-cursor-pointer"
                      style={{ maxWidth: "20vw", maxHeight: "13vw" }}
                      src={data.logo}
                    />
                  </label>
                  <input
                    id="supplier-profile"
                    className="hidden"
                    onChange={handleImageSelection}
                    type="file"
                    accept="image/jpeg,image/png"
                  />
                  <div className="flex flex-col items-center">
                    <span className="pw-upload-instruction">
                      Upload company logo.
                    </span>
                    <span className="pw-upload-instruction">
                      Supported formats: png, jpeg
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex gap-x-12 mt-2">
              <div className="flex flex-col gap-y-2">
                <span className="pw-input-label">
                  Secondary contact name{" "}
                  <span className="pw-mandatory-icon">*</span>
                </span>
                <OutlinedInput
                  id="pw-e2e-scdrycontactname"
                  value={data["secondaryContactName"]}
                  onChange={(e) => handleInputChange(e, "secondaryContactName")}
                />
              </div>
              <div className="flex flex-col gap-y-2">
                <span className="pw-input-label">
                  Secondary contact email ID{" "}
                  <span className="pw-mandatory-icon">*</span>
                </span>
                <OutlinedInput
                  id="pw-e2e-scdrcontactmail"
                  type="email"
                  value={data["secondaryEmail"]}
                  onChange={(e) => handleInputChange(e, "secondaryEmail")}
                />
              </div>
            </div>
            <div className="flex flex-col gap-y-2">
              <span className="pw-input-label">
                Industry type <span className="pw-mandatory-icon">*</span>
              </span>
              {/* <OutlinedInput onChange={(e) => handleInputChange(e, "industry")} /> */}
              <Cascader
                suffixIcon={
                  <CaretDownOutlined className="!pointer-events-none" />
                }
                className="pw-creation-select pw-facility-select pw-e2e-industrytype"
                placeholder="Select Industry Type"
                style={{ width: "25rem" }}
                options={industries}
                onChange={(e) => handleInputChange(e, "industry")}
                value={industryData}
                // showSearch={{ filter }}
              />
            </div>
            <div className="flex flex-col">
              <span className="pw-input-label">
                Registration ID <span className="pw-mandatory-icon">*</span>
              </span>
              <OutlinedInput
                id="pw-e2e-supid"
                value={data["registrationId"]}
                onChange={(e) => handleInputChange(e, "registrationId")}
              />
            </div>
            <div className="flex flex-col pw-width-90">
              <span className="pw-input-label">Address</span>
              <MapsInput
                onChange={(e: any) => handleInputChange(e, "address")}
                isTextArea
              />
            </div>
            <div>
              <div className="pt-4"> Additional Fields</div>
              {(data?.fields || []).map((field: any) => {
                return (
                  <>
                    {/* <span className="pw-input-label">{field.name} <span className="pw-mandatory-icon">*</span></span> */}
                    <div className="flex gap-x-6 items-center my-4">
                      {/* <OutlinedInput placeholder="Field name"
            onChange={(e) => handleAddInputChange(e, field,'name')}
          /> */}
                      <CreatableSelect
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: "25rem",
                          }),
                        }}
                        isClearable
                        onChange={(newValue) => {
                          handleFieldChangeSelect(newValue, field);
                        }}
                        value={{ label: field.name, value: field.name }}
                        onCreateOption={(newValue) => {
                          handleFieldCreateOption(newValue, field);
                        }}
                        onMenuOpen={() => clearFieldInput(field)}
                        options={fieldOptions}
                        className="pw-e2e-fieldName"
                        id="pw-e2e-fieldselection"
                        placeholder="Search Fields or create..."
                      />
                      :
                      <OutlinedInput
                        placeholder="Field value"
                        className="pw-e2e-additionalFieldValue"
                        onChange={(e) =>
                          handleAddInputChange(e, field, "value")
                        }
                      />
                    </div>
                  </>
                );
              })}
              <button
                onClick={(e) => {
                  addNewField();
                }}
                className="mt-4 p-2"
                style={{ background: primaryColor, color: "white" }}
              >
                + Add field
              </button>
            </div>
            <div className="flex flex-col">
              <span className="pw-input-label">Remarks</span>
              {/* <TextField multiline onChange={(e) => handleInputChange(e, "remarks")} 
          maxRows={Infinity} variant="outlined" minRows={2} /> */}
              <TextareaAutosize
                value={data["remarks"]}
                onChange={(e) => handleInputChange(e, "remarks")}
                // disabled={!ready}
                placeholder=""
                className="pw-width-90 pw-input-address pw-address pw-e2e-remarks"
              />
            </div>
            <div style={{ height: "100px", flexShrink: "0" }}></div>
          </div>
          <div
            className="fixed flex justify-end items-center bg-white bottom-0"
            style={{
              height: "70px",
              width: "-webkit-fill-available",
              fontFamily: "Roboto",
              paddingRight: "5vw",
              boxShadow: "0px -5px 5px -5px rgb(128,128,128)",
            }}
          >
            <div className="flex flex-row gap-x-8">
              {/* <Button onClick={handleCancel}>Cancel</Button> */}
              <div
                className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
                onClick={handleCancel}
              >
                {t("Cancel")}
              </div>
              <div style={{ color: "white", display: "flex" }}>
                {/* <div
                    onClick={(e) => enableNext && handleNext()}
                    style={{
                      background: primaryColor,
                      display: "flex",
                      padding: "10px 25px",
                      borderTopLeftRadius: "5px",
                      alignItems: "center",
                      fontSize: "1.1rem",
                      borderBottomLeftRadius: "5px",
                      fontWeight: "700",
                      cursor: "pointer",
                    }}
                  >
                    {" "}
                    {t("Next")}
                  </div> */}
                <button
                  className={`pw-bunit-button-primary pw-bunit-button-save text-white ${
                    enableNext ? "bg-primary" : "bg-neutral-200"
                  }`}
                  onClick={(e) => enableNext && handleNext()}
                  disabled={!enableNext}
                >
                  {t("Next")}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: SUPPLIER_STEPS.PREFERENCES === step ? "block" : "none",
          }}
        >
          <div className="pl-8">
            <div className="flex flex-col">
              <span className="pw-input-label">Frequency of data request</span>

              <FormControl fullWidth>
                <Select
                  id="pw-e2e-datarequestinterval"
                  value={data.preferences.frequency}
                  onChange={(e) => handlePreferenceInput(e, "frequency")}
                >
                  <MenuItem value={"Monthly"}>Monthly</MenuItem>
                  <MenuItem value={"Quarterly"}>Quarterly</MenuItem>
                  <MenuItem value={"Yearly"}>Yearly</MenuItem>
                </Select>
              </FormControl>

              <div className="flex flex-col">
                <span className="pw-input-label">
                  Report window from due date
                </span>
                <OutlinedInput
                  value={data.preferences.reportWindow}
                  id="pw-e2e-reportduedate"
                  onChange={(e) => handlePreferenceInput(e, "reportWindow")}
                />
              </div>
              <div className="flex flex-col">
                <span className="pw-input-label">GHG Emissions</span>
                <RadioGroup
                  onChange={(e) =>
                    handlePreferenceInput(e, "emissionsCaptured")
                  }
                  defaultValue="scope-1-2"
                  value={data.preferences.emissionsCaptured}
                  name="radio-buttons-group"
                >
                  <FormControlLabel
                    className="pw-e2e-scope12"
                    value="scope-1-2"
                    control={<Radio />}
                    label="Scope 1 and 2"
                  />
                  <FormControlLabel
                    className="pw-e2e-scope123"
                    value="scope-1-2-3"
                    control={<Radio />}
                    label="Scope 1, 2 and specific scope 3 categories"
                  />
                  <FormControlLabel
                    className="pw-e2e-productcarbon"
                    value="product"
                    control={<Radio />}
                    label="Product carbon footprint"
                  />
                </RadioGroup>
              </div>
            </div>
          </div>
          <div
            className="fixed flex justify-end items-center bg-white bottom-0"
            style={{
              height: "70px",
              width: "-webkit-fill-available",
              fontFamily: "Roboto",
              paddingRight: "5vw",
              boxShadow: "0px -5px 5px -5px rgb(128,128,128)",
            }}
          >
            <div className="flex flex-row gap-x-8">
              <Button
                className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold"
                onClick={(e) => {
                  setStep(SUPPLIER_STEPS.BASIC_DETAILS);
                }}
              >
                Back
              </Button>
              <div style={{ color: "white", display: "flex" }}>
                <div
                  onClick={(e) => enableSave && handleSave()}
                  style={{
                    background: primaryColor,
                    padding: "4.8px 25px",
                    borderTopLeftRadius: "5px",
                    fontSize: "1.1rem",
                    borderBottomLeftRadius: "5px",
                    fontWeight: "700",
                  }}
                  className={`${
                    enableSave ? "cursor-pointer" : "pw-bg-neutral-200"
                  }`}
                >
                  {isEdit ? "Update" : t("Save")}
                </div>
                {!isEdit ? (
                  <div
                    style={{
                      background: primaryColor,
                      padding: "5px",
                      marginLeft: "0.5px",
                      borderBottomRightRadius: "5px",
                      borderTopRightRadius: "5px",
                    }}
                    className={`${
                      enableSave ? "cursor-pointer" : "pw-bg-neutral-200"
                    }`}
                    onClick={(e) => enableSave && handleClick(e)}
                  >
                    <ArrowDropDownIcon
                      className="pw-box-icon"
                      sx={{ borderRight: "black" }}
                    />
                  </div>
                ) : (
                  ""
                )}
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => handleSaveMenuClose()}
                >
                  <MenuItem onClick={() => handleSaveMenuClose(true)}>
                    {t("Save and send request")}
                  </MenuItem>
                  <MenuItem onClick={() => handleSaveMenuClose(false)}>
                    {t("Save")}
                  </MenuItem>
                </Menu>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
